import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/site";

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="section-pad bg-brand-limestone">
      <div className="container-page">
        <p className="overline mb-3">What clients say</p>
        <h2 className="heading-2 max-w-3xl">Trusted by homeowners across Los Angeles.</h2>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="card-base p-6 flex flex-col gap-4 h-full"
            >
              <Quote className="w-7 h-7 text-brand-olive" strokeWidth={1.5} />
              <blockquote className="font-heading text-lg leading-snug text-brand-ink">
                "{t.text}"
              </blockquote>
              <div className="mt-auto flex items-center justify-between pt-4 border-t border-brand-line">
                <figcaption>
                  <p className="font-semibold text-sm text-brand-ink">{t.name}</p>
                  <p className="text-xs text-brand-ash">{t.location} · {t.project}</p>
                </figcaption>
                <div className="flex gap-0.5">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <Star key={j} className="w-3.5 h-3.5 fill-brand-obsidian text-brand-obsidian" />
                  ))}
                </div>
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
